import slideBackground1 from '../assets/imgs/slide-background-1.jpg'
import slideBackground2 from '../assets/imgs/slide-background-2.jpg'
import slideBackground3 from '../assets/imgs/slide-background-3.jpg'
import recentWork1 from '../assets/imgs/recentWork1.jpg'
import recentWork2 from '../assets/imgs/recentWork2.jpg'
import recentWork3 from '../assets/imgs/recentWork3.jpg'
import recentWork4 from '../assets/imgs/recentWork4.jpg'

import brand1 from '../assets/imgs/brand1.jpg'
import brand2 from '../assets/imgs/brand2.jpg'
import brand3 from '../assets/imgs/brand3.jpg'
import brand4 from '../assets/imgs/brand4.jpg'
import brand5 from '../assets/imgs/brand5.jpg'
import brand6 from '../assets/imgs/brand6.jpg'
import brand7 from '../assets/imgs/brand7.jpg'
import brand8 from '../assets/imgs/brand8.jpg'
import brand9 from '../assets/imgs/brand9.jpg'
import brand10 from '../assets/imgs/brand10.jpg'

import image3 from '../assets/imgs/image3.jpg'
import image4 from '../assets/imgs/image4.jpg'
import image5 from '../assets/imgs/image5.jpg'
import image6 from '../assets/imgs/image6.jpg'

import subSlideBackground1 from '../assets/imgs/subSlideBackground1.jpg'
import subSlideBackground2 from '../assets/imgs/subSlideBackground2.jpg'
import subSlideBackground3 from '../assets/imgs/subSlideBackground3.jpg'

import member1 from '../assets/imgs/member1.jpg'
import member2 from '../assets/imgs/member2.jpg'
import member3 from '../assets/imgs/member3.jpg'
import member4 from '../assets/imgs/member4.jpg'
import member5 from '../assets/imgs/member5.jpg'
import member6 from '../assets/imgs/member6.jpg'
import member7 from '../assets/imgs/member7.jpg'
import member8 from '../assets/imgs/member8.jpg'

import clien1 from '../assets/imgs/client1.jpg'
import clien2 from '../assets/imgs/client2.jpg'
import clien3 from '../assets/imgs/client3.jpg'

import work1 from '../assets/imgs/work1.jpg'
import work2 from '../assets/imgs/work2.jpg'
import work3 from '../assets/imgs/work3.jpg'
import work4 from '../assets/imgs/work4.jpg'
import work5 from '../assets/imgs/work5.jpg'
import work6 from '../assets/imgs/work6.jpg'
import work7 from '../assets/imgs/work7.jpg'
import work8 from '../assets/imgs/work8.jpg'
import work9 from '../assets/imgs/work9.jpg'
import work10 from '../assets/imgs/work10.jpg'
import work11 from '../assets/imgs/work11.jpg'
import work12 from '../assets/imgs/work12.jpg'
import work13 from '../assets/imgs/work13.jpg'
import work14 from '../assets/imgs/work14.jpg'
import work15 from '../assets/imgs/work15.jpg'
import work16 from '../assets/imgs/work16.jpg'

import blog1 from '../assets/imgs/blog1.jpg'
import blog2 from '../assets/imgs/blog2.jpg'
import blog3 from '../assets/imgs/blog3.jpg'
import blog4 from '../assets/imgs/blog4.jpg'
import blog5 from '../assets/imgs/blog5.jpg'
import blog6 from '../assets/imgs/blog6.jpg'
import blog7 from '../assets/imgs/blog7.jpg'
import blog8 from '../assets/imgs/blog8.jpg'
import blog9 from '../assets/imgs/blog9.jpg'
import blog10 from '../assets/imgs/blog10.jpg'

import subBlog1 from '../assets/imgs/subBlog1.jpg'
import subBlog2 from '../assets/imgs/subBlog2.jpg'
import admin from '../assets/imgs/admin.jpg'

import relatedPost1 from '../assets/imgs/relatedPost1.jpg'
import relatedPost2 from '../assets/imgs/relatedPost2.jpg'
import relatedPost3 from '../assets/imgs/relatedPost3.jpg'
import relatedPost4 from '../assets/imgs/relatedPost3.jpg'
import relatedPost5 from '../assets/imgs/relatedPost5.jpg'
import relatedPost6 from '../assets/imgs/relatedPost6.jpg'
import relatedPost7 from '../assets/imgs/relatedPost7.jpg'
import relatedPost8 from '../assets/imgs/relatedPost8.jpg'
import relatedPost9 from '../assets/imgs/relatedPost9.jpg'
import relatedPost10 from '../assets/imgs/relatedPost10.jpg'
import relatedPost11 from '../assets/imgs/relatedPost10.jpg'
import relatedPost12 from '../assets/imgs/relatedPost12.jpg'
import relatedPost13 from '../assets/imgs/relatedPost13.jpg'
import relatedPost14 from '../assets/imgs/relatedPost14.jpg'

import categoryThumb1 from '../assets/imgs/categoryThumb1.jpg'
import categoryThumb2 from '../assets/imgs/categoryThumb2.jpg'
import categoryThumb3 from '../assets/imgs/categoryThumb3.jpg'

import latestProject1 from '../assets/imgs/latestProject1.jpg'
import latestProject2 from '../assets/imgs/latestProject2.jpg'
import latestProject3 from '../assets/imgs/latestProject3.jpg'

// slides
export const oriSlides = [
   {
      categories: ['Design', 'Interface'],
      title: 'We are nominated to agency of year for the second time',
      background: slideBackground1,
   },
   {
      categories: ['Design', 'Interface'],
      title: 'Dolore magnam aliquam quaerat voluptatem nemo enim',
      background: slideBackground2,
   },
   {
      categories: ['Design', 'Interface'],
      title: 'Consequuntur magni sit dolores eos qui ratione duis voluptatem!',
      background: slideBackground3,
   },
]
export const slideLength = oriSlides.length
export const maxSlideIndex = slideLength + 2 - 1
export const slides = [oriSlides[slideLength - 1], ...oriSlides, oriSlides[0]]

// recent works
export const recentWorks = [
   {
      thumbnail: recentWork1,
      title: 'Website design red cover',
      date: '4 November, 2020 in',
      categories: ['Concepts'],
   },
   {
      thumbnail: recentWork2,
      title: 'Graphic design make bootle',
      date: '4 November, 2020 in',
      categories: ['Concepts'],
   },
   {
      thumbnail: recentWork3,
      title: 'Graphic design stylish chair',
      date: '4 November, 2020 in',
      categories: ['Graphic'],
   },
   {
      thumbnail: recentWork4,
      title: 'Objects design yellow glasses',
      date: '4 November, 2020 in',
      categories: ['Graphic'],
   },
]

// our clients
export const clientBrands = [
   brand1,
   brand2,
   brand3,
   brand4,
   brand5,
   brand6,
   brand7,
   brand8,
   brand9,
   brand10,
]

// digital grid
export const imageLinkItems = [image3, image4, image5, image6]

// subslides
export const subSlides = [
   {
      categories: ['Lifestyle'],
      title: 'Consequuntur magni sit dolores eos qui ratione duis voluptatem!',
      background: subSlideBackground1,
   },
   {
      categories: ['Lifestyle'],
      title: 'Dolore magnam aliquam quaerat voluptatem nemo enim',
      background: subSlideBackground2,
   },
   {
      categories: ['Lifestyle'],
      title: 'We are nominated to agency of year for the second time',
      background: subSlideBackground3,
   },
]

// team members
export const teamMembers = [
   {
      name: 'Herman Ledford',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member1,
      link: '/agency',
   },
   {
      name: 'Mel Granville',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member2,
      link: '/agency',
   },
   {
      name: 'Ava Robinson',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member3,
      link: '/agency',
   },
   {
      name: 'Gordon Edwards',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member4,
      link: '/agency',
   },
   {
      name: 'Cassandra Lynn',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member5,
      link: '/agency',
   },
   {
      name: 'Karina Marie',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member6,
      link: '/agency',
   },
   {
      name: 'Eva Lynn',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member7,
      link: '/agency',
   },
   {
      name: 'Alex Robinson',
      detail:
         'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod temporincidi labore et dolore.',
      avatar: member8,
      link: '/agency',
   },
]

// clients say about us
export const oriTestimonials = [
   {
      name: 'JENIFFER BURNS',
      company: 'Creative Heads Inc.',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
      avatar: clien1,
   },

   {
      name: 'GORDON EDWARDS',
      company: 'Creative Heads Inc.',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
      avatar: clien2,
   },

   {
      name: 'ANH KHOA',
      company: 'Creative Heads Inc.',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
      avatar: clien3,
   },
]
export const testimonials = [
   oriTestimonials[oriTestimonials.length - 1],
   ...oriTestimonials,
   oriTestimonials[0],
]

// cases
export const works = [
   {
      thumbnail: work1,
      title: 'Graphic design stylish chair',
      date: '4 November, 2020 in',
      categories: ['Marketing', 'Web Design'],
      createdAt: 1684861439879,
   },
   {
      thumbnail: work2,
      title: 'Graphic design stylish bootle',
      date: '4 November, 2020 in',
      categories: ['Branding', 'Illustration'],
      createdAt: 1684861434644,
   },
   {
      thumbnail: work3,
      title: 'Graphic design stylish cable',
      date: '4 November, 2020 in',
      categories: ['Marketing', 'Web Design'],
      createdAt: 1684861435634,
   },
   {
      thumbnail: work4,
      title: 'Architect design stylish building',
      date: '4 November, 2020 in',
      categories: ['Marketing', 'Web Design'],
      createdAt: 1684861432222,
   },
   {
      thumbnail: work5,
      title: 'Graphic design red cover',
      date: '4 November, 2020 in',
      categories: ['Branding', 'Illustration'],
      createdAt: 1684861431111,
   },
   {
      thumbnail: work6,
      title: 'Graphic design stylish lamp',
      date: '4 November, 2020 in',
      categories: ['Web Design'],
      createdAt: 1684861435456,
   },
   {
      thumbnail: work7,
      title: 'Graphic design stylish books',
      date: '4 November, 2020 in',
      categories: ['Illustration', 'Web Design'],
      createdAt: 1684861437095,
   },
   {
      thumbnail: work8,
      title: 'Graphic design stylish vase',
      date: '4 November, 2020 in',
      categories: ['Illustration', 'Marketing'],
      createdAt: 1684861436574,
   },
   {
      thumbnail: work9,
      title: 'Graphic design stylish chair',
      date: '4 November, 2020 in',
      categories: ['Branding', 'Web Design'],
      createdAt: 1684861436666,
   },
   {
      thumbnail: work10,
      title: 'Website design red cover',
      date: '4 November, 2020 in',
      categories: ['Illustration', 'Web Design'],
      createdAt: 1684861438888,
   },
   {
      thumbnail: work11,
      title: 'Graphic design stylish globe',
      date: '4 November, 2020 in',
      categories: ['Web Design'],
      createdAt: 1684861433333,
   },
   {
      thumbnail: work12,
      title: 'Graphic design stylish chair',
      date: '4 November, 2020 in',
      categories: ['Marketing'],
      createdAt: 1684861434563,
   },
   {
      thumbnail: work13,
      title: 'Graphic design stylish chair',
      date: '4 November, 2020 in',
      categories: ['Illustration'],
      createdAt: 1684861432882,
   },
   {
      thumbnail: work14,
      title: 'Graphic design stylish furniture and macbook pro',
      date: '3 November, 2020 in',
      categories: ['Branding'],
      createdAt: 1684861432224,
   },
   {
      thumbnail: work15,
      title: 'Objects design blue and black',
      date: '3 November, 2020 in',
      categories: ['Marketing', 'Web Design'],
      createdAt: 1684861435734,
   },
   {
      thumbnail: work16,
      title: 'Graphic design stylish vase',
      date: '3 November, 2020 in',
      categories: ['Branding', 'Illustration'],
      createdAt: 1684861434566,
   },
]

// blogs
export const blogs = [
   {
      title: 'We are nominated to agency of year for the second time',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog1,
      categories: ['Media', 'Networks'],
      date: 'November 2, 2020',
   },
   {
      title: 'Dolore magnam aliquam quaerat voluptatem nemo enim',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog2,
      categories: ['Media', 'Networks'],
      date: 'November 2, 2020',
   },
   {
      title: 'Consequuntur magni sit dolores eos qui ratione duis voluptatem!',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog3,
      categories: ['Media', 'Networks'],
      date: 'November 2, 2020',
   },
   {
      title: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog4,
      categories: ['Media', 'Networks'],
      date: 'November 2, 2020',
   },
   {
      title: 'Consequuntur magni sit dolores eos qui ratione duis voluptatem!',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog5,
      categories: ['Media', 'Networks'],
      date: 'November 2, 2020',
   },
   {
      title: 'We are nominated to agency of year for the second time',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog6,
      categories: ['Media', 'Networks'],
      date: 'November 2, 2020',
   },
   {
      title: 'Consequuntur magni sit dolores eos qui ratione duis voluptatem!',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog7,
      categories: ['Creative', 'Fashion'],
      date: 'November 2, 2020',
   },
   {
      title: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog8,
      categories: ['Creative', 'Fashion'],
      date: 'November 2, 2020',
   },
   {
      title: 'Dolore magnam aliquam quaerat voluptatem nemo enim',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog9,
      categories: ['Creative', 'Fashion'],
      date: 'November 2, 2020',
   },
   {
      title: 'We are nominated to agency of year for the second time',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: blog10,
      categories: ['Creative', 'Fashion'],
      date: 'November 2, 2020',
   },
]

// sub blogs
export const subBlogs = [
   {
      author: 'By admin',
      avatar: admin,
      title: 'Dolore magnam aliquam quaerat voluptatem',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      thumbnail: subBlog1,
      categories: ['Living'],
      date: 'November 3, 2020',
      commands: 0,
      createdAt: 1684861439879,
   },

   {
      author: 'By admin',
      avatar: admin,
      title: 'We are nominated to agency of year for the second time',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      thumbnail: subBlog2,
      categories: ['Reason'],
      date: 'November 3, 2020',
      commands: 0,
      createdAt: 1684861439879,
   },
]

// related posts
export const relatedPosts = [
   {
      id: 1,
      thumbnail: relatedPost1,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 2,
      thumbnail: relatedPost2,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 3,
      thumbnail: relatedPost3,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 4,
      thumbnail: relatedPost4,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 5,
      thumbnail: relatedPost5,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 6,
      thumbnail: relatedPost6,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 7,
      thumbnail: relatedPost7,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 8,
      thumbnail: relatedPost8,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 9,
      thumbnail: relatedPost9,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 10,
      thumbnail: relatedPost10,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 11,
      thumbnail: relatedPost11,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 12,
      thumbnail: relatedPost12,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 13,
      thumbnail: relatedPost13,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
   {
      id: 14,
      thumbnail: relatedPost14,
      text: 'We are nominated to agency of year for the',
      date: '03 Nov 2020',
      comments: 0,
      likes: 1,
   },
]

// categories page
export const categories = [
   {
      title: 'Consequuntur magni sit dolores eos qui ratione duis voluptatem!',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: categoryThumb1,
      categories: ['Interface'],
      date: 'November 2, 2020',
      likes: 1,
   },

   {
      title: 'Dolore magnam aliquam quaerat voluptatem nemo enim',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: categoryThumb2,
      categories: ['Interface'],
      date: 'November 2, 2020',
      likes: 1,
   },

   {
      title: 'We are nominated to agency of year for the second time',
      desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
      createdAt: 1684861439879,
      thumbnail: categoryThumb3,
      categories: ['Interface'],
      date: 'November 2, 2020',
      likes: 1,
   },
]

// latest projects - services page
export const latestProjects = [
   {
      thumbnail: latestProject1,
      createdAt: 1684861439879,
   },
   {
      thumbnail: latestProject2,
      createdAt: 1684861439879,
   },
   {
      thumbnail: latestProject3,
      createdAt: 1684861439879,
   },
]
